import type { Component } from 'vue';

const load = () => import('./ui/index.vue');

export const FeedbackModal: Component = defineAsyncComponent(() =>
  load().then((m: { default: Component }) => m.default),
);

export const prefetchFeedbackModal = (): void => {
  load().catch(() => null);
};
